import { IncomingMessage } from 'http'

import { shouldConsumeViewCredits, ShouldConsumeViewCredits_Viewer } from './should-consume-credits'

export type ShouldBlockDocument_Document = {
  hasCreditsToViewDocument: boolean | null
}

export type ShouldBlockDocument_Viewer = ShouldConsumeViewCredits_Viewer & {
  viewContentBlocked: boolean | null
}

export function shouldBlockDocument(
  req: IncomingMessage,
  document: ShouldBlockDocument_Document,
  viewer: ShouldBlockDocument_Viewer | null
) {
  return (
    (shouldConsumeViewCredits(req, viewer) && !document.hasCreditsToViewDocument) ||
    Boolean(viewer?.viewContentBlocked)
  )
}
